(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9666],{

/***/ 31142:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/keylogger",
      function () {
        return __webpack_require__(19446);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 76039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useAndroidDevicePagedData; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95629);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82017);
/* harmony import */ var src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26771);




/** INSTALLED_APP 按包名去重，兼容 bundleid / bundleId */ function getAppBundleId(item) {
    return (item === null || item === void 0 ? void 0 : item.bundleid) || (item === null || item === void 0 ? void 0 : item.bundleId) || "";
}
function dedupeInstalledApps(items) {
    const seen = new Set();
    const result = [];
    for (const item of items){
        const key = getAppBundleId(item);
        if (key) {
            if (seen.has(key)) continue;
            seen.add(key);
        }
        result.push(item);
    }
    return result;
}
/**
 * Android Cloud / Local 分页列表 Hook，设备切换时重置分页并取消旧请求。
 *
 * @param {Object} options
 * @param {'local'|'cloud'} options.source - 数据源：Local 或 Gcloud
 * @param {string} options.category - 接口 category 参数
 * @param {number} options.limit - 每页条数
 * @returns {{ context: Object|null, data: Array, loading: boolean, total: number, loadNext: Function, reload: Function, setDateRange: Function }}
 */ function useAndroidDevicePagedData(param) {
    let { source , category , limit  } = param;
    const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    const [total, setTotal] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const [context, setContext] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const scopeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const revisionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    const pageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        offset: 0,
        maxNum: false,
        loading: false
    });
    /** @type {React.MutableRefObject<{ startTime: number, endTime: number } | null>} 日期筛选区间（毫秒） */ const dateRangeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const loadPage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function(offset) {
        let scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scopeRef.current, revision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : revisionRef.current;
        if (!scope || pageRef.current.loading || pageRef.current.maxNum) return;
        pageRef.current.loading = true;
        const { context: scopedContext , signal , isCurrent  } = scope;
        const request = source === "local" ? src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getLocalAndroidAll */ .gH : src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getGcloudAll */ .U1;
        const params = {
            category,
            offset,
            limit
        };
        if (source === "local") params.deviceUdid = (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__/* .readLocalDeviceUdid */ .S)(scopedContext);
        if (source === "cloud" && (scopedContext === null || scopedContext === void 0 ? void 0 : scopedContext.physicalDeviceKey)) {
            params.deviceUdid = scopedContext.physicalDeviceKey;
        }
        // 日期筛选走接口：不筛选时不传，请求与改动前一致
        const range = dateRangeRef.current;
        if (range) {
            if (range.startTime != null) params.startTime = range.startTime;
            if (range.endTime != null) params.endTime = range.endTime;
        }
        try {
            var ref;
            const response = await request({
                username: source === "local" ? (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__/* .readUserEmail */ .t)() : (scopedContext === null || scopedContext === void 0 ? void 0 : scopedContext.username) || "",
                params
            }, {
                signal
            });
            if (!isCurrent() || revision !== revisionRef.current) return;
            const contents = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.contents;
            if (contents) {
                setData((old)=>{
                    const merged = offset === 0 ? [
                        ...contents
                    ] : [
                        ...old,
                        ...contents
                    ];
                    return category === "INSTALLED_APP" ? dedupeInstalledApps(merged) : merged;
                });
                setTotal(response.data.totalCount || 0);
                pageRef.current.offset = offset;
                if (contents.length < limit) pageRef.current.maxNum = true;
            } else {
                pageRef.current.maxNum = true;
            }
            setLoading(false);
        } catch (error) {
            if (isCurrent() && revision === revisionRef.current && (error === null || error === void 0 ? void 0 : error.code) !== "ERR_CANCELED") {
                ;
                setLoading(false);
            }
        } finally{
            if (isCurrent() && revision === revisionRef.current) pageRef.current.loading = false;
        }
    }, [
        category,
        limit,
        source
    ]);
    // 设备切换：重置分页 state 并从第一页重新请求
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((_, scope)=>{
        scopeRef.current = scope;
        revisionRef.current += 1;
        dateRangeRef.current = null;
        pageRef.current = {
            offset: 0,
            maxNum: false,
            loading: false
        };
        setData([]);
        setLoading(true);
        setTotal(0);
        setContext(scope.context);
        loadPage(0, scope, revisionRef.current);
    }, [
        loadPage
    ]));
    const loadNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const page = pageRef.current;
        if (!page.maxNum && !page.loading) loadPage(page.offset + limit);
    }, [
        limit,
        loadPage
    ]);
    const reload = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const scope = scopeRef.current;
        if (!scope) return;
        revisionRef.current += 1;
        pageRef.current = {
            offset: 0,
            maxNum: false,
            loading: false
        };
        setData([]);
        setLoading(true);
        setTotal(0);
        loadPage(0, scope, revisionRef.current);
    }, [
        loadPage
    ]);
    /**
   * 设置日期筛选区间并重新从第一页拉取（区间由接口过滤，不是本地过滤）。
   * @param {{ startTime: number, endTime: number } | null} range - 毫秒时间戳；null 表示清除筛选
   */ const setDateRange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((range)=>{
        dateRangeRef.current = range;
        reload();
    }, [
        reload
    ]);
    return {
        context,
        data,
        loading,
        total,
        loadNext,
        reload,
        setDateRange
    };
}


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 19446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90948);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61906);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50607);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15378);
/* harmony import */ var src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76039);
/* harmony import */ var src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31909);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34745);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74743);














// 自定义隐藏滚动条且保留滚动特性
const ScrollDiv = (0,_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)("div")({
    "-msOverflowStyle": "none",
    /* 适用于 IE 和 Edge */ scrollbarWidth: "thin",
    /* 适用于 Firefox，设置滚动条为细 */ "&::-webkit-scrollbar": {
        width: "4px"
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        /* 设置滚动条滑块的颜色 */ borderRadius: "10px"
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1"
    },
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
const Keylogger = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("common");
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useDispatch */ .I0)();
    const [isExpand, setIsExpand] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) //展开日期选择
    ;
    const [showData, setShowData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) //展示数据
    ;
    const [showDate, setShowDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) //展示日期
    ;
    const [date, setDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([
        "All"
    ]) //日期
    ;
    const [from, setFrom] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("") //开始日期
    ;
    const [to, setTo] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("") //结束日期
    ;
    const [fromDate, setFromDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null) //开始日期(dayjs)
    ;
    const [toDate, setToDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null) //结束日期(dayjs)
    ;
    const [fromTime, setFromTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("") //开始日期时间戳
    ;
    const [toTime, setToTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("") //结束日期时间戳
    ;
    const [searchData, setSearchData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("") //搜索内容
    ;
    const [dates, setDates] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { context , data: allData , loading: isLoading , loadNext , setDateRange  } = (0,src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_6__/* .useAndroidDevicePagedData */ .v)({
        source: "local",
        category: "KEY_LOGGER",
        limit: 100
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setShowData([]);
        setIsExpand(false);
        setShowDate(false);
        setDate([
            "All"
        ]);
        setFrom("");
        setTo("");
        setFromDate(null);
        setToDate(null);
        setFromTime("");
        setToTime("");
        setSearchData("");
        setDates([]);
    }, [
        context === null || context === void 0 ? void 0 : context.requestKey
    ]);
    const handleImageError = (event)=>{
        event.target.src = "/images/android/com.example.variousdata.png";
    };
    const dom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // 滚动百分比
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    // 获取滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handScroll = ()=>{
            if (dom.current) {
                const { scrollTop , scrollHeight , clientHeight  } = dom.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = dom.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handScroll);
            }
        };
    }, []);
    // 监听滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (scroll >= 100) loadNext();
    }, [
        loadNext,
        scroll
    ]);
    const onApply = ()=>{
        if (!from || !to) return;
        setDate([
            from,
            to
        ]);
        setShowDate(false);
    };
    //筛选数据
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const filteredByName = allData.filter((item)=>item.app.toLowerCase().includes(searchData.toLowerCase()));
        let results = filteredByName;
        // 如果有 fromTime 和 toTime，则进一步筛选
        if (fromTime && toTime) {
            results = results.filter((item)=>{
                const itemTime = dayjs__WEBPACK_IMPORTED_MODULE_4___default()(item.time).valueOf();
                return fromTime <= itemTime && itemTime <= toTime;
            });
        }
        // 更新显示数据
        setShowData(results);
    }, [
        fromTime,
        toTime,
        allData,
        searchData
    ]);
    //更新 fromTime 和 toTime（同时把区间交给接口筛选）
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (date.length === 1 && date[0] !== "All") {
            const { startTime , endTime  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_7__/* .buildPresetTimeParams */ .z6)(date[0]);
            setFromTime(startTime);
            setToTime(endTime);
            setDateRange({
                startTime,
                endTime
            });
        } else if (date.length === 2) {
            const { startTime: startTime1 , endTime: endTime1  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_7__/* .buildTimeParams */ .W2)(date);
            setFromTime(startTime1);
            setToTime(endTime1);
            setDateRange({
                startTime: startTime1,
                endTime: endTime1
            });
        } else {
            setFromTime("");
            setToTime("");
            setDateRange(null);
        }
    }, [
        date,
        setDateRange
    ]);
    // 日期按钮 + 下拉框（dropdown 用 portal 渲染到 body，避免被 sticky header 的白底遮挡）
    const buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [dropdownPos, setDropdownPos] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        top: 0,
        right: 0
    });
    const updateDropdownPos = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setDropdownPos({
                top: rect.bottom + 6,
                right: Math.max(8, window.innerWidth - rect.right)
            });
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showDate) {
            updateDropdownPos();
            window.addEventListener("resize", updateDropdownPos);
            window.addEventListener("scroll", updateDropdownPos, true);
            return ()=>{
                window.removeEventListener("resize", updateDropdownPos);
                window.removeEventListener("scroll", updateDropdownPos, true);
            };
        }
    }, [
        showDate,
        updateDropdownPos
    ]);
    const button = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            ref: buttonRef,
            className: "min-w-[172px] w-auto h-[40px] bg-[#2A99FF] border border-[#E5E7EB] rounded-[8px] flex justify-center items-center cursor-pointer relative px-[10px] whitespace-nowrap",
            onClick: (e)=>{
                e.stopPropagation();
                if (!showDate) updateDropdownPos();
                setShowDate((val)=>!val);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    className: "ml-[2px]",
                    src: "/images/record-screen/calendar2.svg",
                    width: 20,
                    height: 20,
                    alt: "calendar"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "text-[14px] leading-[16px] text-white mx-[10px] whitespace-nowrap",
                    children: [
                        date.length === 1 && date[0],
                        date.length === 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                date[0],
                                " ~ ",
                                date[1]
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_12__/* .motion.div */ .E.div, {
                    initial: {
                        rotate: 0
                    },
                    animate: {
                        rotate: showDate ? 180 : 0
                    },
                    transition: {
                        duration: 0.2
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                        src: "/images/record-screen/union.svg",
                        width: 16,
                        height: 16,
                        alt: "drop down"
                    })
                })
            ]
        });
    const dropdown = showDate && typeof document !== "undefined" ? /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_12__/* .motion.div */ .E.div, {
        initial: {
            opacity: 0,
            y: -6
        },
        animate: {
            opacity: 1,
            y: 0
        },
        transition: {
            duration: 0.18
        },
        className: "fixed z-[800] w-[340px] bg-[#FFFFFF] rounded-[12px] shadow-[0_8px_28px_rgba(0,0,0,0.14)] border border-[#EFF0F2] overflow-hidden",
        style: {
            top: dropdownPos.top,
            right: dropdownPos.right
        },
        onClick: (e)=>{
            e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "px-[16px] pt-[14px] pb-[12px] border-b border-[#F2F3F5]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-[13px] font-[600] text-[#1F2329] mb-[10px]",
                        children: t("Quick filter")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-wrap gap-[8px]",
                        children: [
                            "All",
                            "Today",
                            "Last 7 days",
                            "Last 14 days",
                            "Last 30 days",
                            "Last Year"
                        ].map((preset)=>{
                            const active = date.length === 1 && date[0] === preset;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "px-[12px] py-[5px] text-[12px] rounded-[8px] cursor-pointer transition-colors ".concat(active ? "bg-[#2A99FF] text-white" : "bg-[#F4F6F9] text-[#525866] hover:bg-[#E8F1FF] hover:text-[#2A99FF]"),
                                onClick: ()=>{
                                    setDate([
                                        preset
                                    ]);
                                    setShowDate(false);
                                },
                                children: t(preset)
                            }, preset);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "px-[16px] py-[14px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-[13px] font-[600] text-[#1F2329] mb-[10px]",
                        children: t("Custom range")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                className: "flex-1",
                                picker: "date",
                                format: "YYYY-MM-DD",
                                placeholder: t("Start date"),
                                value: fromDate,
                                onChange: (date, dateString)=>{
                                    setFromDate(date);
                                    setFrom(dateString);
                                },
                                allowClear: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[#BBB] text-[14px]",
                                children: "-"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                className: "flex-1",
                                picker: "date",
                                format: "YYYY-MM-DD",
                                placeholder: t("End date"),
                                value: toDate,
                                onChange: (date, dateString)=>{
                                    setToDate(date);
                                    setTo(dateString);
                                },
                                allowClear: true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex border-t border-[#F2F3F5]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 py-[11px] text-center text-[14px] text-[#525866] cursor-pointer hover:bg-[#F7F8FA]",
                        onClick: ()=>setShowDate(false),
                        children: t("Cancel")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[1px] bg-[#F2F3F5]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 py-[11px] text-center text-[14px] ".concat(from && to ? "text-[#2A99FF] font-[600] cursor-pointer hover:bg-[#F0F7FF]" : "text-[#A8ABB3] cursor-not-allowed"),
                        onClick: ()=>onApply(),
                        children: t("apply")
                    })
                ]
            })
        ]
    }), document.body) : null;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const title = t("Keylogger");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_9__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_9__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    // 埋点上报事件
    // useEffect(() => {
    //   if (allData.length <= 0) return
    //   if (Array.isArray(allData) && allData.length > 0) {
    //     const events = allData.map(item => ({
    //       event_name: 'Info_Open_Web_Keylogger_Info',
    //       properties: {
    //         app: item?.app || '',
    //         text: item?.text || '',
    //         time: item?.time || '',
    //       }
    //     }))
    //   }
    // }, [allData])
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ScrollDiv, {
            className: "w-full !h-[calc(var(--vh2)*100-215px)] smj:!h-[calc(var(--vh2)*100-92px)] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] px-[48px] sm:px-[10px] bg-white relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "sticky top-0 bg-[#FFFFFF]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex justify-between items-center pt-[30px] pb-[12px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center w-[75%] smj:w-[50%]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-[53%] relative smj:w-[100%]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "h-[40px] w-[165px] sm:w-[145px] border-[#E3E3E5] border-[1px] rounded-[8px] flex items-center justify-center cursor-pointer",
                                                        onClick: ()=>{
                                                            setIsExpand(!isExpand);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "text-[16px] text-[#000000] font-[600] mr-[24px] sm:mr-[12px]",
                                                                children: searchData || t("App name")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                src: "/images/record-screen/drop-down.svg",
                                                                width: 20,
                                                                height: 20,
                                                                alt: "expand and collapse",
                                                                className: "".concat(isExpand && "rotate-[180deg]", " transition-all duration-300 sm:w-[16px] sm:h-[16px]")
                                                            })
                                                        ]
                                                    }),
                                                    isExpand && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "absolute z-10 bg-[#FFFFFF] rounded-[6px] mt-[2px] px-2 py-4 h-auto w-[165px] [box-shadow:0px_0px_3px_0px_#0000001A]",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "relative flex justify-end",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        className: "w-full text-[14px] leading-[21px] placeholder:text-[#666666] text-[#282938] border-[#666CFF] border-[1px] rounded-[4px] font-[400] pl-2 py-1",
                                                                        placeholder: t("Search app"),
                                                                        onInput: (e)=>{
                                                                            setSearchData(e.target.value);
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "absolute top-0 right-0 flex items-center h-full pr-2",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                            src: "/images/contacts/search.svg",
                                                                            className: "w-[16px] h-[16px]",
                                                                            width: 16,
                                                                            height: 16,
                                                                            alt: "Search"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "px-2 py-1 text-[#222222] text-[16px] leading-[24px] rounded-[4px] hover:bg-[#EAEAEA] w-full mt-[14px] cursor-pointer",
                                                                onClick: ()=>{
                                                                    setSearchData("Chrome");
                                                                    setIsExpand(!isExpand);
                                                                },
                                                                children: "Chrome"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "px-2 py-1 text-[#222222] text-[16px] leading-[24px] rounded-[4px] hover:bg-[#EAEAEA] w-full my-[10px] cursor-pointer",
                                                                onClick: ()=>{
                                                                    setSearchData("WhatsApp");
                                                                    setIsExpand(!isExpand);
                                                                },
                                                                children: "WhatsApp"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "px-2 py-1 text-[#222222] text-[16px] leading-[24px] rounded-[4px] hover:bg-[#EAEAEA] w-full cursor-pointer",
                                                                onClick: ()=>{
                                                                    setSearchData("Instagram");
                                                                    setIsExpand(!isExpand);
                                                                },
                                                                children: "Instagram"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "px-2 py-1 text-[#222222] text-[16px] leading-[24px] rounded-[4px] hover:bg-[#EAEAEA] w-full mt-[10px] cursor-pointer",
                                                                onClick: ()=>{
                                                                    setSearchData("Snapchat");
                                                                    setIsExpand(!isExpand);
                                                                },
                                                                children: "Snapchat"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-[16px] leading-[24px] text-[#222222] font-[600] smj:hidden",
                                                children: t("Text")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: button()
                                    })
                                ]
                            })
                        }),
                        dropdown,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "overflow-auto !h-[calc(var(--vh2)*100-298px)] smj:!h-[calc(var(--vh2)*100-176px)]",
                            ref: dom,
                            children: [
                                showData.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-[16px] text-[#2222222] leading-[24px] flex justify-between items-center px-3 py-[18px] smj:hidden border-b border-b-[#DCDCDC] ",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex items-center w-[75%]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex items-center w-[53%]",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                src: "https://cos.spyx.com/" + item.iconUrl,
                                                                width: 42,
                                                                height: 42,
                                                                alt: "icon",
                                                                className: "w-[42px] h-[42px] mr-[21px]",
                                                                onError: handleImageError
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "font-[500]",
                                                                children: item.app
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "font-[400] ml-[21px] flex-1 min-w-0 break-words",
                                                        children: item.text
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: dayjs__WEBPACK_IMPORTED_MODULE_4___default()(item.time).format("DD/MM/YYYY HH:mm")
                                            })
                                        ]
                                    }, index)),
                                showData.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center px-[10px] py-[12px] smjs:hidden border-b border-b-[#DCDCDC] ",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "https://cos.spyx.com/" + item.iconUrl,
                                                width: 36,
                                                height: 36,
                                                alt: "app",
                                                className: "mr-3",
                                                onError: handleImageError
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-[-webkit-fill-available]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "text-[16px] leading-[24px] text-[#222222] font-[600]",
                                                                children: item.app
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "text-[14px] leading-[24px] text-[#8A8A8E]",
                                                                children: dayjs__WEBPACK_IMPORTED_MODULE_4___default()(item.time).format("DD/MM/YYYY HH:mm")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "mt-[10px] text-[15px] leading-[22px] text-[#8A8A8E]",
                                                        children: item.text
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index))
                            ]
                        })
                    ]
                }),
                isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                }) : null,
                allData.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none",
                    children: [
                        t("It appears theres no data to show here yet"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        t("If data exists it may take up to 1 hour to download and appear"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        t("We suggest checking back in a little while")
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Keylogger);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1033,8914,3368,1675,5378,607,9774,2888,179], function() { return __webpack_exec__(31142); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);